<template>
  <div class="order-detail-card-wrap">
    <h5 class="card-title" style="margin-bottom: 20px;">订单信息</h5>
    <div class="detail-wrap order-msg-wrap">
      <div class="order-number-wrap">
        <span>订单编号</span>
        <div>
          <em>{{ orderDetail.orderId }}</em>
          <b class="copy-btn" :data-clipboard-text="orderDetail.orderId"
            >复制</b
          >
        </div>
      </div>
      <div>
        <span>下单时间</span>
        <em>{{ orderDetail.createTime }}</em>
      </div>
    </div>
    <div v-show="showToast">
      <Toast :text="tip" :duration="1000"></Toast>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import Toast from "../Popup/Toast.vue";
export default {
  name: "orderMessage",
  components: { Toast },
  props: {
    orderDetail: {
      type: Object,
    },
  },
  data() {
    return {
      tip: "",
      showToast: false,
    };
  },
  computed: {},
  mounted() {
    const clipboard = new Clipboard(".copy-btn");
    clipboard.on("success", () => {
      this.tip = "复制成功";
      this.handleShowToast();
    });
    clipboard.on("error", () => {
      this.tip = "复制失败";
      this.handleShowToast();
    });
  },
  methods: {
    handleShowToast() {
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 1000);
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";

//订单信息
.order-msg-wrap {
  & > div {
    display: flex;
    justify-content: space-between;
  }
  .order-number-wrap {
    margin-bottom: 24px;
  }
  b {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.5px;
    color: #00b9ef;
    position: relative;
    padding-left: 20px;
    cursor: pointer;
    &::before {
      content: "";
      width: 1px;
      height: 10px;
      background: #eee;
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #000;
  }
  em {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    color: #4c4f59;
  }
}
</style>
